import { useEffect } from 'react';
export const useScrollToView = ({ isCurrent, ref }) => {
    useEffect(() => {
        if (isCurrent && ref?.current?.scrollIntoView) {
            ref.current.scrollIntoView({ block: 'nearest' });
        }
    }, [ref, isCurrent]);
};
